import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Button, Form } from "react-bootstrap";
import { useLoader } from '../../_helper/LoaderContext';
import { addDepartment, updateDepartment } from './service/department-service';
import { toast } from 'react-toastify';

export default function AddDepartment({ handleClose, data, getList }) {

    const { t } = useTranslation()
    const [department, setDepartment] = useState("");
    const [error, setError] = useState("");
    const { setLoading } = useLoader();

    const handleSubmit = async () => {
        if (!department.trim()) {
            setError(t("Please enter department"));
            return;
        }

        setLoading(true)
        try {
            if (data) {
                const form_data = new FormData();
                form_data.append("name", department);
                form_data.append("departmentId", data._id);
                const res = await updateDepartment(form_data)
                if (res.data.success == true) {
                    toast.success(res.data.message)
                    getList()
                }
            } else {
                const form_data = new FormData();
                form_data.append("name", department);
                const res = await addDepartment(form_data)
                if (res.data.success == true) {
                    toast.success(res.data.message)
                    getList()
                }
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
        setError("");
        handleClose();
    };

    useEffect(() => {
        if (data) {
            setDepartment(data.name)
        }
    }, [data])

    return (
        <>
            {/* <Modal.Header closeButton>
                <Modal.Title>{data ? ` ${t("Edit Department")}` : `${t("Add Department")}`}</Modal.Title>
            </Modal.Header> */}
            <Modal.Body className={data ? "py-2 px-3" : "pt-1 pb-2 px-3"}>
                <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                    <Form.Group controlId="department" className="mb-0">
                        <Form.Label className="form-label mb-1" style={{ fontSize: "12.5px", fontWeight: 500 }}>
                            {t("Department Name")}{" "}
                            <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            size="sm"
                            placeholder={t("Enter department name")}
                            value={department}
                            onChange={(e) => {
                                setDepartment(e.target.value);
                                setError("");
                            }}
                            isInvalid={!!error}
                            style={{ height: "36px", fontSize: "13px" }}
                        />
                        {error && (
                            <Form.Control.Feedback type="invalid" style={{ fontSize: "11px", marginTop: "2px" }}>
                                {error}
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className="py-2 px-3 border-top d-flex justify-content-end gap-2">
                <Button variant="primary" size="sm" className="px-3" onClick={handleSubmit}>
                    {data ? t("Update") : t("Create")}
                </Button>
                <Button variant="secondary" size="sm" className="px-3" onClick={handleClose}>
                    {t("Close")}
                </Button>
            </Modal.Footer>
        </>
    )
}
